import React from 'react';
import DatePicker from './DatePicker';

export function MergedEntriesComposer({ newEvt, setNewEvt, addButtonLabel, inlineCalendar, fullWidthAddButton = false }: { newEvt: any; setNewEvt: React.Dispatch<React.SetStateAction<any>>; addButtonLabel?: string; inlineCalendar?: boolean; fullWidthAddButton?: boolean }) {
    const [open, setOpen] = React.useState<boolean>(false);
    const [draftDate, setDraftDate] = React.useState<string | undefined>(undefined);
    const [draftNote, setDraftNote] = React.useState<string>('');
    const entries: Array<{ when: string; note: string }> = Array.isArray(newEvt.entries) ? newEvt.entries : [];

    const startCompose = () => {
        setOpen(true);
        const isoNow = new Date().toISOString();
        setDraftDate(draftDate || isoNow);
        setDraftNote(draftNote || '');
    };
    const addToday = () => {
        setOpen(true);
        const isoNow = new Date().toISOString();
        setDraftDate(isoNow);
    };
    const saveEntry = () => {
        if (!draftDate) return;
        const item = { when: draftDate, note: (draftNote || '').trim() };
        setNewEvt((prev: any) => ({ ...prev, entries: [...(prev.entries || []), item] }));
        setOpen(false);
        setDraftNote('');
    };
    const editEntry = (idx: number) => {
        const it = entries[idx];
        setDraftDate(it.when);
        setDraftNote(it.note || '');
        setOpen(true);
        // Remove and re-add on save
        setNewEvt((prev: any) => ({ ...prev, entries: (prev.entries || []).filter((_: any, i: number) => i !== idx) }));
    };
    const removeEntry = (idx: number) => {
        setNewEvt((prev: any) => ({ ...prev, entries: (prev.entries || []).filter((_: any, i: number) => i !== idx) }));
    };

    return (
        <div className="space-y-2">
            <div className={fullWidthAddButton ? 'space-y-2' : 'flex items-center justify-between'}>
                <label className="text-sm font-semibold text-white">Follow up</label>
                {!open && (
                    fullWidthAddButton ? (
                        <button
                            type="button"
                            className="w-full inline-flex items-center justify-center gap-2 px-3 py-2 text-sm rounded-md border border-gray-700 bg-gray-800 hover:bg-gray-700 text-white"
                            onClick={startCompose}
                            title={addButtonLabel || 'Add Follow up'}
                        >
                            {addButtonLabel || 'Add Follow up'}
                        </button>
                    ) : (
                        <button type="button" className="inline-flex items-center gap-1 px-2 py-1 text-xs rounded-md border border-gray-700 bg-gray-800 hover:bg-gray-700 text-white" onClick={startCompose} title="Add Follow up">
                            <span className="sr-only">Add Follow up</span>
                            {/* plus icon mimic with + sign to avoid extra imports */}
                            +
                        </button>
                    )
                )}
            </div>
            {entries.length > 0 && (
                <div className="space-y-2">
                    {entries.map((it, idx) => (
                        <div key={idx} className="flex items-start justify-between gap-2 p-2 bg-gray-900 border border-gray-700 rounded-md">
                            <div className="min-w-0">
                                <div className="text-sm text-gray-200">{new Date(it.when).toLocaleString()}</div>
                                {it.note ? (<div className="text-xs text-gray-400 whitespace-pre-wrap break-words">{it.note}</div>) : null}
                            </div>
                            <div className="flex items-center gap-1 shrink-0">
                                <button type="button" className="px-2 py-1 text-xs border border-gray-700 rounded-md text-gray-300 hover:bg-gray-700" onClick={() => editEntry(idx)}>Edit</button>
                                <button type="button" className="px-2 py-1 text-xs border border-gray-700 rounded-md text-gray-300 hover:bg-gray-700" onClick={() => removeEntry(idx)}>Remove</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {!open ? (
                <div />
            ) : (
                <div className="space-y-2">
                    <DatePicker value={draftDate} onChange={(iso) => setDraftDate(iso)} placeholder="Select date and time" withTime inline={!!inlineCalendar} />
                    <textarea value={draftNote} onChange={(e) => setDraftNote(e.target.value)} rows={3} className="w-full px-3 py-2 bg-gray-900 border border-gray-700 rounded-md text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-600" placeholder="What happened" />
                    <div className="flex justify-end gap-2">
                        <button type="button" className="px-3 py-1.5 text-sm rounded-md border border-gray-700 text-gray-300 hover:bg-gray-700" onClick={() => { setOpen(false); setDraftNote(''); }}>Cancel</button>
                        <button type="button" className="px-3 py-1.5 text-sm rounded-md border border-gray-700 bg-gray-800 hover:bg-gray-700 text-white" onClick={saveEntry} disabled={!draftDate}>Done</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MergedEntriesComposer;
